import Skeleton from 'react-loading-skeleton';

function BreadcrumbSkeleton() {
  return <Skeleton height="1rem" width={100} />;
}

export default BreadcrumbSkeleton;
